import { render, staticRenderFns } from "./EventCatering.vue?vue&type=template&id=0239da34&scoped=true"
import script from "./EventCatering.vue?vue&type=script&lang=js"
export * from "./EventCatering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239da34",
  null
  
)

export default component.exports